import { createReducer, on } from '@ngrx/store';
import { 
    fetchBulkImportHistory,
    fetchBulkImportHistoryFail,
    fetchBulkImportHistorySuccess,
    importRecord,
    importRecordSuccess,
    resetState,
} from './bulk-import.action';

export interface BulkImportRecordsState {
    loading: boolean;
    error: any;
    total: number;
    bulkItems: any[];
}

export const initialState: BulkImportRecordsState = {
    loading: false,
    error: null,
    total: 0,
    bulkItems: [],
};

export const BulkImportRecordReducer = createReducer(

    initialState,

    //Fetch All Records
    on(importRecord, (state) => {
        return { ...state, loading: true, error: null };
    }),
    on(importRecordSuccess, (state) => {
        return { ...state, loading: false, error: null };
    }),

     //FETCH BULK HISTORY
    on(fetchBulkImportHistory, (state,) => {
        return { ...state, loading: true, error: null };
    }),

    on(fetchBulkImportHistorySuccess, (state, { bulkItems, total }) => {
        return { ...state, bulkItems, loading: false, total, error: null };
    }),

    on(fetchBulkImportHistoryFail, (state, { error }) => {
        return { ...state, error, loading: false };
    }),

    //Reset
    on(resetState, () => initialState)  // Reset action handler
    
);